import React from "react";

const ModalOne = () => {
  return (
    <div className="popup_informations">
      {/*<div className="image">
        <img src="img/thumbs/4-3.jpg" alt="" />
        <div
          className="main"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "img/service/1.jpg"
            })`,
          }}
        ></div>
        </div>*/}
      {/* End big image */}

      <div className="description">
        <h3>Diritto Civile</h3>
        <p>
        Lo studio fornisce la migliore assistenza nelle problematiche e controversie di natura civilistica, ivi comprendendo i seguenti ambiti: 
        </p>
        <div className="in_list">
          <ul>
            <li>
              <p>Recupero dei crediti;</p>
            </li>
            <li>
              <p>Contratti e obbligazioni;</p>
            </li>
            <li>
              <p>Separazione e divorzio, affidamento e tutela dei figli, famiglia di fatto, convivenza more uxorio, unioni civili;</p>
            </li>
            <li>
              <p>Stato delle persone, interdizione, inabilitazione, amministrazione del sostegno;</p>
            </li>
            <li>
              <p>Diritto della proprietà intellettuale;</p>
            </li>
            <li>
              <p>Questioni condominiali;</p>
            </li>
            <li>
              <p>Sfratti;</p>
            </li>
            <li>
              <p>Accettazione d’eredità, questioni successorie, donazioni;</p>
            </li>
            <li>
              <p>Risarcimento danni-Responsabilità civile;</p>
            </li>
          </ul>
        </div>
        {/* End list */}
        {/*<p>
          Streets empty that are usually busy are remarkable and can evoke the
          sense of historical pictures from before the invention of the
          motorcar. Other things that are different at the moment will be queues
          to get into stores and the lines marked out on the floor to show how
          far apart we should be.
      </p>*/}
      </div>
    </div>
  );
};

export default ModalOne;
